import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "time-circle",
  "use": "time-circle-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"time-circle\">\n    <path fill-rule=\"evenodd\" d=\"M10 0c5.519 0 10 4.481 10 10s-4.481 10-10 10S0 15.519 0 10 4.481 0 10 0zm-.464 11.489a1.25 1.25 0 0 1-.787-1.162V6.25a1.25 1.25 0 0 1 2.5 0v3.341l2.042 1.179a1.25 1.25 0 0 1-1.25 2.165l-2.505-1.446z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol